module.exports = "/img/_/_/_/assets/images/creeper/book/common//25.jpg?56b5431367efcf3db21a8915e50ca4d3";